import { VIDEO_PLAY } from '../constants/gtmce';

export default {
  data() {
    return {
      video_play: VIDEO_PLAY,
    };
  },
  methods: {
    /**
     * @param {Object} params - GA4 params
     * @param {Array} videos - Array of video elements
     * @param {Number} divisor - Number of percent buckets ( 10%-90% )
     */
    videoTrackingGA4(params = {}, videos = [], videoSrcGetter = (src) => src, divisor = 10) {
      if (!this.$gtmPush) {
        return;
      }

      const videos_status = {};

      const eventHandler = (e) => {
        switch (e.type) {
          // This event type is sent everytime the player updated it's current time,
          // We're using for the % of the video played.
          case 'timeupdate':
            // Let's set the save the current player's video time in our status object
            videos_status[e.target.id].current = Math.round(e.target.currentTime);
            // We just want to send the percent events once
            let pct = Math.floor(100 * videos_status[e.target.id].current / e.target.duration);
            for (let j in videos_status[e.target.id]._progress_markers) {
              if (pct >= j && j > videos_status[e.target.id].greatest_marker) {
                videos_status[e.target.id].greatest_marker = j;
              }
            }
            // current bucket hasn't been already sent to GA?, let's push it to GTM
            if (videos_status[e.target.id].greatest_marker && !videos_status[e.target.id]._progress_markers[videos_status[e.target.id].greatest_marker]) {
              videos_status[e.target.id]._progress_markers[videos_status[e.target.id].greatest_marker] = true;
              // dataLayer.push({
              //   'event': 'video_play',
              //   'gaEventCategory': 'HTML5 Video',
              //   'gaEventAction': 'Progress ' + videos_status[e.target.id].greatest_marker + '%',
              //   // We are using sanitizing the current video src string, and getting just the video name part
              //   'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
              // });
              this.$gtmPush({
                ...this.video_play,
                ...params,
                slug: videoSrcGetter(e.target.currentSrc),
                value: parseFloat(videos_status[e.target.id].greatest_marker),
                'gaEventCategory': 'HTML5 Video',
                'gaEventAction': 'Progress ' + videos_status[e.target.id].greatest_marker + '%',
                'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
              });
            }
            break;
          // This event is fired when user's click on the play button
          case 'play':
            // dataLayer.push({
            //   'event': 'video_play',
            //   'element_name': 'video_play',
            //   'element_id': 'video_play',
            //   'parent_name': 'video_play',
            //   'parent_id': 'video_play',
            //   'slug': e.target.currentSrc,
            //   'gaEventCategory': 'HTML5 Video',
            //   'gaEventAction': 'Play',
            //   'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
            // });
            this.$gtmPush({
              ...this.video_play,
              ...params,
              slug: videoSrcGetter(e.target.currentSrc),
              value: 0,
              'gaEventCategory': 'HTML5 Video',
              'gaEventAction': 'Play',
              'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
            });
            break;

          // If the user ends playing the video, an Finish video will be pushed ( This equals to % played = 100 )
          case 'ended':
            // dataLayer.push({
            //   'event': 'video_play',
            //   'gaEventCategory': 'HTML5 Video',
            //   'gaEventAction': 'Finished',
            //   'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
            // });
            this.$gtmPush({
              ...this.video_play,
              ...params,
              slug: videoSrcGetter(e.target.currentSrc),
              value: 100,
              'gaEventCategory': 'HTML5 Video',
              'gaEventAction': 'Finished',
              'gaEventLabel': decodeURIComponent(e.target.currentSrc.split('/')[e.target.currentSrc.split('/').length - 1])
            });
            break;
          default:
            break;
        }
      };

      for (let i = 0; i < videos.length; i++) {
        // In order to have some id to reference in our status object, we are adding an id to the video objects
        // that don't have an id attribute.
        let videoTagId;
        if (!videos[i].getAttribute('id')) {
          // Generate a random alphanumeric string to use is as the id
          videoTagId = 'html5_video_' + Math.random().toString(36).slice(2);
          videos[i].setAttribute('id', videoTagId);
        } // Current video has alredy a id attribute, then let's use it <img draggable="false" class="emoji" alt="?" src="https://s.w.org/images/core/emoji/2/svg/1f642.svg">
        else {
          videoTagId = videos[i].getAttribute('id');
        }
        // Video Status Object declaration
        videos_status[videoTagId] = {};
        // We'll save the highest percent mark played by the user in the current video.
        videos_status[videoTagId].greatest_marker = 0;
        // Let's set the progress markers, so we can know afterwards which ones have been already sent.
        videos_status[videoTagId]._progress_markers = {};
        for (let j = 0; j < 100; j++) {
          videos_status[videoTagId].progress_point = divisor * Math.floor(j / divisor);
          videos_status[videoTagId]._progress_markers[videos_status[videoTagId].progress_point] = false;
        }
        // On page DOM, all players currentTime is 0
        videos_status[videoTagId].current = 0;
        // Now we're setting the event listeners.
        videos[i].addEventListener("play", eventHandler, false);
        videos[i].addEventListener("pause", eventHandler, false);
        videos[i].addEventListener("ended", eventHandler, false);
        videos[i].addEventListener("timeupdate", eventHandler, false);
      }
    }
  }
}
